import React from "react";
import { capitalize } from "../helpers/helpers";

function TextBlock({ title, value }) {
    return (
        <div className="flex flex-col lg:w-1/2">
            <label htmlFor="product" className="font-bold block mb-2">
                {title}
            </label>
            <div
                id="product"
                className={`w-full  bg-slate-200 p-4 shadow-none rounded-md`}
            >
                <span>{capitalize(value)}</span>
            </div>
        </div>
    );
}

export default TextBlock;
